module.exports = __webpack_public_path__ + "img/radio-bio-bio.0fd64ad8.png";